<div class="main_content">
  <app-breadcrumb></app-breadcrumb>
  <div #page_section class="page_main_sec">
    <div class="OpenSearch_main_sec">
      <!-- title bar section Start-->
      <div class="container-fluid">
        <!-- <div class="post-nav-wrap">
          <div class="title-wrap">
            <p class="title">Open Search</p>
          </div>
          <ul class="nav top-actions">
            <li>
              <a [routerLink]="['/home']">
                <i class="material-icons theme-text-color">home</i>
              </a>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- title bar section  End-->
    </div>

    <!-- advance Search section Start-->
    <div class="tab-content">
      <div>
        <!-- Table View -->
        <div class="table_card_sec mb_0">
          <div class="table scroll_table">
            <div class="row advance-search-wrp">
              <!--<div class="bx-sub-title mb-3">Filter Option</div>-->
              <div class="col-lg-3">

                <!-- <app-dropdown-multiselect #ddlDocselect [lstDropdownOption]="docTypeList" [labelText]="'Work Item Type'"
                  [allSelected]="true">
                </app-dropdown-multiselect> -->

                <!-- <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label>Work Item Type</mat-label>
                  <mat-select [(ngModel)]="selectedDocType" (selectionChange)="getAdvanceSearchFields()">
                    <mat-option [value]="option.value"
                      *ngFor="let option of docTypeList">
                      {{ option.text }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                <app-dropdown-multiselect #ddlWorkItem [labelText]="'Work Item Type'" [lstDropdownOption]="docTypeList"
                  [allSelected]="true" (Raise_event_selection_changed)="onWorkItemSelect($event)">
                </app-dropdown-multiselect>
              </div>
              <div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label>URN</mat-label><input matInput placeholder="URN" [(ngModel)]="lstURN">
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <app-dropdown-multiselect #ddlProcessmultiselect [labelText]="'Queue'" [lstDropdownOption]="lstProcess"
                  [allSelected]="true">
                </app-dropdown-multiselect>
              </div>
              <div class="col-lg-3">
                <app-dropdown-multiselect #ddlPriority [labelText]="'Priority'" [lstDropdownOption]="lstPriority"
                  [allSelected]="true">
                </app-dropdown-multiselect>
              </div>
              <div class="col-lg-3">
                <mat-form-field [style.width.%]="100">
                  <mat-label>Invoice Date Range</mat-label>
                  <mat-date-range-input [min]="commonService.minDate" [rangePicker]="picker"
                    [formGroup]="invoiceCreationDateRange">
                    <input matStartDate formControlName="start_date" #startdate placeholder="Start Date" [max]="maxDate"
                      (dateChange)="onInvoiceCreationDateChanges()">
                    <input matEndDate formControlName="end_date" #endDate placeholder="End Date" [max]="maxDate"
                      (dateChange)="onInvoiceCreationDateChanges()">
                  </mat-date-range-input>
                  <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                    (click)="resetInvoiceCreationDateRange()">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>


              </div>
              <!--Xerox Specific Field Search start-->
              <!--<div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label>Invoice Total</mat-label><input matInput placeholder="Invoice Amount Value/Range" [(ngModel)]="invoiceAmount">
                </mat-form-field>
              </div>-->
              <!--Xerox Specific Field Search end-->
              <div *ngFor="let field of advanceSearchFields" [ngSwitch]="field.control_type | lowercase"
                class="col-lg-{{ field.control_type == 'TEXTAREA' ? 6 : 3 }}">
                <mat-form-field *ngSwitchCase="'textbox'" [style.width.%]="100">
                  <input matInput [placeholder]="field.field_name" [(ngModel)]="field.search_value"
                    [type]="field.value_type"
                    (change)="field.search_value=setDecimalPlaces(field.search_value,field.precision_point,field.validation_type);" />
                </mat-form-field>

                <mat-form-field appearance="legacy" *ngSwitchCase="'dropdown'" [style.width.%]="100">
                  <mat-label>{{ field.field_name }}</mat-label>
                  <mat-select [(ngModel)]="field.search_value" (click)="searchText.focus()" (focus)="searchText.focus()"
                    (closed)="searchText.value=''">
                    <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off" class="mat-select-search"
                      placeholder="Search {{field.field_name}}">
                    <mat-option [value]="option.id"
                      *ngFor="let option of field.options| listFilter:{'name':searchText.value}">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                   <!-- Commented by imran 08-01-2026 -->
                  <!-- <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix mat-icon-button
                    (click)="
                    $event.stopPropagation();openFilterFieldMagnifySearchModal(field)">
                    <mat-icon title="search">search</mat-icon>
                  </button> -->
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'date'" [style.width.%]="100">
                  <input matInput readonly [(ngModel)]="field.search_value" [matDatepicker]="picker"
                    [placeholder]="field.field_name" [min]="commonService.minDate">
                  <button *ngIf="field.search_value!=''" mat-button matSuffix mat-icon-button
                    (click)="field.search_value=''">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'textarea'" [style.width.%]="100">
                  <textarea matInput [placeholder]="field.field_name" [(ngModel)]="field.search_value"
                    rows="1"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-12 btn-opensearch">
                <button type="button" class="btncss me-2 btn_primary" (click)="getOpenSearchData();">
                  Search
                </button>
                <button type="button" class="btncss me-2 btn_secondary" (click)="ClearOpenSearch()">
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- advance search section end-->

      <!-- Basic Grid for filtered Data to display Start -->
      <div class="grid_panel">
        <app-basic-gridview *ngIf="advanceSearchGridData.length > 0" [lstData]="advanceSearchGridData"
                    [columnsToHide]="advanceSearchColumnsToHide" [gridTitle]="'Filtered Data'"
                    [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                    [showPagination]="true" (cellClickEvent)="advanceSearchCellClick($event)"
                    [exportToExcelFileName]="'Open-Search-Result'"
                    [columnsToExcludeFromExport]="['DOCUMENT_DETAIL_ID']">
        </app-basic-gridview>
      </div>
      <!-- Basic Grid for filtered Data to display Start -->
    </div>
  </div>
</div>


<app-transaction-lite></app-transaction-lite>
